var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-top"},[_c('div',{staticClass:"logo",style:({backgroundImage: 'url(' + _vm.logo + ')'}),on:{"click":_vm.goIndex}}),_vm._v(" "),_c('ul',{staticClass:"r"},[_c('li',[_c('span',{on:{"click":_vm.signUser}},[_vm._v("登录")])]),_vm._v(" "),_c('li',[_c('span',{on:{"click":_vm.signUser}},[_vm._v("注册")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-3d9f6bea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/header/nav-top.vue
// module id = odf5
// module chunks = 1